const getFormatedPrice = (number, currencySymbol  = '€') => parseFloat(number).toFixed(2).replace('.', ',') + currencySymbol

export default getFormatedPrice